import { v5 as uuidv5 } from 'uuid'

const UUID_NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'

export function documentMetadataUserEditEntryId(
  siteId: string,
  documentId: string
): string {
  return uuidv5(
    `document-metadata-user-edit:${siteId}:${documentId}`,
    UUID_NAMESPACE_URL
  )
}
